
import React, { useEffect } from 'react';
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Button } from "@/components/ui/button";
import { ChevronLeft } from "lucide-react";

const MeineVision = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { data: images } = useQuery({
    queryKey: ["images", "meine-vision"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("images")
        .select("*")
        .eq("section", "meine-vision" as any)
        .order('created_at', { ascending: false });
      
      if (error) throw error;
      return data;
    },
  });

  const getBackgroundImage = () => {
    if (images && images.length > 0) {
      const { data } = supabase.storage
        .from('images')
        .getPublicUrl(images[0].storage_path);
      return data.publicUrl;
    }
    return null;
  };

  const handleNavigateBack = () => {
    const section = document.getElementById('ns3');
    if (section) {
      const offset = -80;
      const elementPosition = section.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset + offset;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }
  };

  const imageUrl = getBackgroundImage();

  return (
    <div className="bg-gradient-to-r from-[#243949] to-[#517fa4]" id="vision">
      <div className="container mx-auto px-4 py-8">
        <div className="flex items-center justify-between mb-8">
          <div className="w-[40px]"></div>
          
          <h2 className="text-xl md:text-2xl text-white font-bold text-center uppercase flex-grow">
            „Eine Trauerfeier ist Blättern im Album des Lebens – der Geliebte ist gegenwärtig, man lacht und weint"
          </h2>
          
          <div className="w-[40px]"></div>
        </div>

        <div className="max-w-4xl mx-auto">
          {/* First text box */}
          <div className="group relative bg-white/10 backdrop-blur-sm py-2.5 px-4 rounded-lg shadow-lg border border-white/20 mb-4">
            <p className="text-base md:text-lg text-white leading-relaxed text-left">
              Sie haben einen <strong>geliebten Menschen verloren</strong>. Das schmerzt, eine Lücke entsteht. Ich <strong>begleite Sie</strong> gern <strong>in Ihrer Trauer</strong>.
            </p>
          </div>

          {/* Second text box */}
          <div className="group relative bg-white/10 backdrop-blur-sm py-2.5 px-4 rounded-lg shadow-lg border border-white/20 mb-4">
            <p className="text-base md:text-lg text-white leading-relaxed text-left">
              Ich bin <strong>ehemaliger Pfarrer</strong>, <strong>freier Redner</strong>, halte zudem <strong>ehrenamtlich Gottesdienste und</strong> bin <strong>Poetry Slammer</strong>.
            </p>
          </div>

          {/* Third text box */}
          <div className="group relative bg-white/10 backdrop-blur-sm py-2.5 px-4 rounded-lg shadow-lg border border-white/20 mb-4">
            <p className="text-base md:text-lg text-white leading-relaxed text-left">
              Als Pfarrer gehörten <strong>Beerdigungen</strong> zu meinen <strong>erfüllendsten Aufgaben</strong>. Im Gespräch mit den Angehörigen war es oft, als <strong>blätterten wir gemeinsam im Fotoalbum des Lebens</strong> – der <strong>geliebte Mensch noch einmal ganz nah: mal</strong> zum Heulen <strong>traurig</strong>, dann wieder <strong>zum Lachen</strong> schön. <strong>Echt und tief.</strong>
            </p>
          </div>

          {/* Fourth text box */}
          <div className="group relative bg-white/10 backdrop-blur-sm py-2.5 px-4 rounded-lg shadow-lg border border-white/20 mb-4">
            <p className="text-base md:text-lg text-white leading-relaxed text-left">
              Ich möchte Ihnen gerne helfen, <strong>Ihrer Trauer</strong>, aber auch <strong>Ihrer Dankbarkeit Worte</strong> zu verleihen: <strong>Das Leben</strong> Ihres <strong>geliebten Menschen</strong> in Worten zu <strong>malen</strong> und so <strong>Abschied</strong> zu <strong>nehmen</strong>, wie es <strong>ihm gefallen</strong> würde.
            </p>
          </div>

          {/* Fifth text box */}
          <div className="group relative bg-white/10 backdrop-blur-sm py-2.5 px-4 rounded-lg shadow-lg border border-white/20 mb-4">
            <p className="text-base md:text-lg text-white leading-relaxed text-left">
              Ich <strong>gestalte</strong> die <strong>Trauerfeier</strong> so, wie <strong>Sie</strong> es wünschen: <strong>geistlich, frei oder etwas dazwischen.</strong>
            </p>
          </div>

          {/* Signature */}
          <div className="group relative bg-white/10 backdrop-blur-sm py-2.5 px-4 rounded-lg shadow-lg border border-white/20 mb-8">
            <p className="text-base md:text-lg text-white leading-relaxed text-left italic">
              Ihr Torsten T. Resack
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MeineVision;
